import React, { useState, useEffect } from "react";
import { Avatar, Box, getColor, Typography } from "fds";
import "./index.scss";
import IframeComm from "react-iframe-comm";
import utilsCommon from "../../../shared/utils/common";
import { Workgroup } from "../../../types/workgroup";
import useChatStore from "../../../redux/dispatcher/useChatStore";
import { t } from "i18next";
import NameTag from "../../../components/NameTag";
import currentUrlUtils from "../../../shared/utils/currentUrlUtils";
const WorkgroupChat = ({ workgroupInfo }: { workgroupInfo?: Workgroup }) => {
  const { chatId } = currentUrlUtils.getAllFirstQuery();

  const { chatUrl } = useChatStore();
  const [targetChatId, changeTargetChatId] = useState(chatId ?? "");
  const [iframeLoad, changeIframeLoad] = useState(false);

  const [chatOpenUrl, changeChatOpenUrl] = useState();
  useEffect(() => {
    if (!workgroupInfo) return;
    handleChatUrl(workgroupInfo?.workgroupId);
  }, [workgroupInfo]);
  useEffect(() => {
    changeTargetChatId(targetChatId);
  }, [chatId]);
  useEffect(() => {
    if (!targetChatId || window.origin === "127.0.0.1:3000") return;
    const checkChatActiveTimer = setInterval(() => {
      let ecoChat = document.getElementById("eco-chat") as HTMLIFrameElement;
      if (!targetChatId || !ecoChat || !ecoChat.contentWindow) return;
      if (
        ecoChat.contentWindow.document.getElementsByClassName(
          "wrapmsgr_messages"
        )
      ) {
        clearInterval(checkChatActiveTimer);
        changeIframeLoad(true);
      }
    }, 500);
  }, [targetChatId]);
  useEffect(() => {
    if (!targetChatId || !iframeLoad || window.origin === "127.0.0.1:3000")
      return;
    goToSpecificChat();
  }, [iframeLoad, targetChatId]);

  const handleChatUrl = async (workgroupId: string): Promise<any> => {
    const resp: any = await chatUrl(workgroupId);
    if (resp.payload) {
      changeChatOpenUrl(resp.payload);
    }
  };
  const goToSpecificChat = () => {
    let ecoChat = document.getElementById("eco-chat") as HTMLIFrameElement;
    if (!targetChatId || !ecoChat || !ecoChat?.contentWindow) return;

    let innerEcoChat = ecoChat.contentWindow.document;
    const goUpChat = setInterval(() => {
      innerEcoChat
        .getElementsByClassName("wrapmsgr_messages")[0]
        .scrollTo({ top: 0, behavior: "smooth" });
      if (innerEcoChat.getElementById(targetChatId)) {
        innerEcoChat.getElementsByClassName("wrapmsgr_messages")[0].scrollTo({
          top: innerEcoChat.getElementById(targetChatId)?.offsetTop ?? 0,
          behavior: "smooth",
        });
        clearInterval(goUpChat);
      }
    }, 500);
  };

  return (
    <Box width={"100%"} classes={"workgroupChat"}>
      {utilsCommon.getChatAvailibility() === "true" ? (
        chatOpenUrl ? (
          <Box width={"100%"}>
            <Box width={"calc(100% - 292px)"}>
              <IframeComm
                attributes={{
                  src: targetChatId
                    ? chatOpenUrl + `&messageId=${targetChatId}`
                    : chatOpenUrl,
                  id: "eco-chat",
                  width: "100%",
                  height: "100%",
                  display: "block",
                }}
                id={"eco-chat"}
              />
            </Box>
            <Box direction="column" classes="workgroupChat-members">
              <Typography type="body2_rg" fontWeight="bold" classes="mg mb-8">
                {t("common.member")}
              </Typography>

              {workgroupInfo?.members.map((user) => (
                <Box classes="mg mb-16">
                  <NameTag user={user} width={"100%"} withoutUserId={false} />
                </Box>
              ))}
            </Box>
          </Box>
        ) : (
          ""
        )
      ) : (
        <Box
          direction="column"
          alignItems="center"
          justifyContent="center"
          width={"100%"}
        >
          <img
            width={300}
            height={160}
            alt={"Home"}
            src={require("../../../shared/images/pages/Chat/bg_chat_need_license.png")}
          />
          <Typography classes={"mg mt-40"} type="h3">
            {t("workgroup.chat.needLicense1")}
          </Typography>
          <Typography
            classes={"mg mt-2"}
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {t("workgroup.chat.needLicense2")}
          </Typography>
          <Typography
            classes={"mg mt-2"}
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {t("workgroup.chat.needLicense3")}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default WorkgroupChat;
